import { render, staticRenderFns } from "./planAddModel.vue?vue&type=template&id=5216768c&scoped=true&"
import script from "./planAddModel.vue?vue&type=script&lang=js&"
export * from "./planAddModel.vue?vue&type=script&lang=js&"
import style0 from "./planAddModel.vue?vue&type=style&index=0&id=5216768c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216768c",
  null
  
)

export default component.exports